import React, { useState } from 'react';

export default function InteractiveButton({
	href,
	target,
	rel,
	ariaLabel,
	title,
	style,
	children,
	className,
	onClick,
}) {
	const [hover, setHover] = useState(false);
	const [active, setActive] = useState(false);
	const transform = active ? 'translateY(2px) scale(0.98)' : hover ? 'translateY(-6px) scale(1.02)' : 'none';
	const baseShadow = style && style.boxShadow ? style.boxShadow : 'none';
	const shadowColor = String(baseShadow).trim().split(/\s+/).pop();
	let boxShadow = baseShadow;
	if (active) boxShadow = '2px 2px 0 rgba(0,0,0,0.2)';
	else if (hover) {
		if (baseShadow === 'none') boxShadow = '6px 6px 0 #000';
		else boxShadow = `8px 8px 0 ${shadowColor}`;
	}

	return (
		<a
			href={href}
			target={target}
			rel={rel}
			aria-label={ariaLabel}
			title={title}
			className={className}
			onClick={onClick}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => { setHover(false); setActive(false); }}
			onMouseDown={() => setActive(true)}
			onMouseUp={() => setActive(false)}
			style={{
				...style,
				transform,
				boxShadow,
				cursor: 'pointer',
				transition: style && style.transition ? style.transition : 'transform 140ms ease, box-shadow 140ms ease',
			}}
		>
			{children}
		</a>
	);
}
